<template>
  <page-wrapper :has-pad="true" title="Juristic Feature">
    <div v-if="project" class="wrapper">
      <div class="row">
        <div class="col-lg-3 project-container me-3">
          <div class="project-group mb-3">
            <img :src="projectGroup.logo" class="logo img-fluid" />
          </div>
          <div v-for="detail in projectDetail" :key="detail.label" class="mb-4">
            <div class="label mb-1">{{ detail.label }}</div>
            <div class="text">{{ detail.text }}</div>
          </div>
        </div>

        <div class="col">
          <div class="text-end mb-3">
            <sc-button
              v-if="!isEdit"
              variant="secondary"
              @click="handleClickEditButton()"
              >แก้ไข</sc-button
            >
            <div v-if="isEdit" class="">
              <sc-button
                class="me-2"
                variant="ghost"
                @click="handleClickEditButton()"
                >ยกเลิก</sc-button
              >
              <sc-button variant="primary" @click="handleSave"
                >บันทึก</sc-button
              >
            </div>
          </div>

          <project-service-selector v-model="services" :disabled="!isEdit">
          </project-service-selector>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient, backendAdminClient } from "@/dependencies"
import ProjectServiceSelector from "../components/ProjectServiceSelector"

export default {
  components: {
    PageWrapper,
    ProjectServiceSelector,
    ScButton,
  },
  data() {
    const project = null
    const services = []
    const isEdit = false
    const oldServices = []

    return {
      project,
      services,
      isEdit,
      oldServices,
    }
  },
  computed: {
    projectDetail() {
      if (!this.project) {
        return null
      }

      const projectType = {
        L: "แนวราบ",
        H: "แนวสูง",
        NSL: "แนวราบ",
        NSH: "แนวสูง",
        B: "อาคาร",
      }

      const {
        project_name: name,
        project_code: code,
        project_type: projectTypeCode,
        address_road: addressRoad = "",
        pre_tumbon: preTumbon = "",
        tumbon_name: tumbonName = "",
        pre_amphur: preAmphur = "",
        amphur_name: amphurName = "",
        province_name: provinceName = "",
        zip_code: zipCode = "",
      } = this.project

      const type = projectType[projectTypeCode]

      const addressText = [
        addressRoad,
        preTumbon,
        tumbonName,
        preAmphur,
        amphurName,
        provinceName,
        zipCode,
      ]
        .map((t) => (t ? t.trim() : ""))
        .filter((t) => t !== "")
        .join(" ")
        .trim()
      const address = addressText === "" ? "-" : addressText

      return [
        { label: "ชื่อ", text: name },
        { label: "รหัส", text: code },
        { label: "ประเภท", text: type },
        { label: "ที่อยู่", text: address },
      ]
    },
    projectGroup() {
      if (!this.project) {
        return null
      }

      const logo = this.project.project_icon

      return { logo }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.setupData()
    },
    async setupData() {
      return Promise.all([this.setupProject(), this.setupProjectService()])
    },
    async setupProject() {
      const project = await this.fetchData()

      this.project = project
    },
    async setupProjectService() {
      const service = await this.fetchServiceData()

      this.services = service
      this.oldServices = service
    },
    async fetchData() {
      const { id } = this.$route.params

      const response = await baanRueJaiClient.admin.projects.get(id)

      return response.data.result
    },
    async fetchServiceData() {
      const { id } = this.$route.params

      const response =
        await backendAdminClient.projectJuristic.getProjectServiceByProjectId(
          id,
        )

      return response.data.result
    },
    async handleClickEditButton() {
      if (this.isEdit) {
        // eslint-disable-next-line no-alert
        const confirmCancel = window.confirm("ยืนยันการยกเลิกการแก้ไข")

        if (confirmCancel) {
          if (this.oldServices !== this.services) {
            await this.setupProjectService()
          }
          this.isEdit = false
        }
      } else {
        this.isEdit = true
      }
    },
    async handleSave() {
      const { id } = this.$route.params

      const addedServiceIds = this.services
        .filter(
          (service) =>
            !this.oldServices.some(
              (oldService) => oldService.id === service.id,
            ),
        )
        .map((service) => service.id)

      const removedServiceIds = this.oldServices
        .filter(
          (oldService) =>
            !this.services.some((service) => service.id === oldService.id),
        )
        .map((oldService) => oldService.id)

      const serviceIds = {
        add: addedServiceIds,
        delete: removedServiceIds,
      }

      await backendAdminClient.projectJuristic.updateProjectServiceFeatures(
        id,
        { serviceIds },
      )

      this.isEdit = false

      await this.setupProjectService()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0 0 0;
}

.label {
  font-size: 16px;
  color: black;
}

.text {
  font-size: 16px;
  color: black;
  font-weight: bold;
}

.project-group {
  display: grid;
  grid-template-columns: 120px 1fr;
  grid-gap: 15px;
  align-items: center;

  .logo {
    border: $border;
    border-radius: 6px;
    width: 100%;
  }
}

.project-container {
  flex: 0 1 280px;
  width: 280px;
}
</style>
